import { cas, leadtime_converter, purity, lead_time, quantity, unit, shipping_temp, check_is_cold } from '../services/instruments'

const full_danger_manufaturer = ['Macklin', 'Aladdin', 'Sigma', 'MedChemExpress']
// Эта переменная до тех пор пока MCE не войдет в поставщика Lisa
const special_danger_manufaturer = ['Macklin', 'Aladdin', 'Sigma']

const supplier = (product: productInterface) => {
  return product.danger && special_danger_manufaturer.includes(product.manufacturer) ? 'Lisa' : 'Helen'
}

const manufacturer = (product: productInterface) => {
  return product.danger && full_danger_manufaturer.includes(product.manufacturer)
    ? `${product.manufacturer} Class I`
    : product.manufacturer.replace('CST', 'Cell Signaling Technology')
}

const price_unit = (product: productInterface) => {
  return product.danger && full_danger_manufaturer.includes(product.manufacturer) ? '$' : unit(product.price_unit)
}

const formatted_lead_time = (product: productInterface) => {
  if (product.manufacturer === 'Macklin' && product.boiling && parseFloat(product.boiling.replace('>', '')) < 60) return 'НИЗКОКИПЯЩИЙ'
  if (product.danger && full_danger_manufaturer.includes(product.manufacturer)) return ''
  if (product.danger) return 'Недоступно к заказу'

  return leadtime_converter(product.leadtime, product.manufacturer)
}

const price = (product: productInterface) => {
  if (product.danger && full_danger_manufaturer.includes(product.manufacturer)) return ''
  if (product.danger) return 'ЗАПРЕЩЕНО'

  if (product.manufacturer === 'Synaptic Systems' && product.submanufacturer === 'Bioec') return 'Уточняйте цену на Neobioscience.com'
  return product.price || ''
}

const xlsx_formula = (product: productInterface) => {
  return `${product.sku.toLocaleUpperCase()}∩${cas(product.cas)}∪${manufacturer(product)}⊂${supplier(product)}⊃${product.item}⊄${formatted_lead_time(product)}⊅${price(product)}⊆${price_unit(product)}⊇${purity(product.purity)}∏${shipping_temp(product.shipping_temp)}∐${quantity(product.quantity.toLocaleLowerCase())}⨒${unit(product.unit)}⨗`
}

export { supplier, manufacturer, price_unit, purity, lead_time, formatted_lead_time, cas, quantity, unit, shipping_temp, check_is_cold, price, xlsx_formula }
